module.exports = __webpack_public_path__ + "494cd07c/img/document.e2130c6b.svg";